import axios from "axios";

export const getSkillsTests = async (ondemandId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_REPO}/v1/repo_aden/ondemand/${ondemandId}/skill-tests`)
        return response.data.response;
    } catch (error) {
        console.log(error)
    }
}